import React from 'react';
import PropTypes from 'prop-types';
import './Divider.css';

/**
 * Divider — a hairline, optionally with a word between two halves ("eller"
 * between sign-in methods and an e-mail field).
 */
const Divider = ({ label, className = '', ...rest }) => (
  <div
    className={['ds-divider', label && 'ds-divider--labelled', className].filter(Boolean).join(' ')}
    role="separator"
    aria-label={label || undefined}
    {...rest}
  >
    {label && <span className="ds-divider__label typo-body-sm" aria-hidden="true">{label}</span>}
  </div>
);

Divider.propTypes = {
  /** Word shown between the two hairlines */
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Divider;
